export default "__VITE_ASSET__BaZN$Ycu__"